(ns dashboard.entity.analysis.tree
  (:require ["react" :as react]
            [clojure.set :as set]
            [dashboard.entity.analysis.list :as analysis.list]
            [dashboard.entity.analysis.profile :as analysis.profile]))

(defn- row-visible?
  [is-expanded
   asa
   {:keys [active-query
           linked-construct-ids
           search-result-construct-ids
           display-construct-ids
           selected-construct-ids
           analysis-linked
           expanded expand-all]}]
  (let [expanded (set expanded)
        display-construct-ids (set display-construct-ids)
        children (set (:tree/children asa))
        ancestors (set (:tree/ancestors asa))
        selected-construct-ids (set selected-construct-ids)
        construct-id (:construct-id asa)]
   (or
    ; Root Elements
    (and (zero? (:tree/depth asa))
         (or (not active-query)
             (contains? display-construct-ids construct-id)))
    ; Selected and Previously Selected Analyses
    (seq (set/intersection
          (conj children
                construct-id)
          (apply conj
                 linked-construct-ids
                 selected-construct-ids)))
    ; With Query enabled, show search results
    (and active-query
         (seq (set/intersection
               (conj children construct-id)
               (set search-result-construct-ids))))
    ; ???
    (and analysis-linked (not active-query))
    ; Expanded
    (contains? expanded construct-id)
    (contains? expanded (:parent-id asa))
    (and (seq ancestors)
         (seq expanded)
         (or (set/subset? ancestors expanded)
             (= ancestors expanded)))
    is-expanded
    expand-all)))

(defn get-analysis-tree-displayed-construct-ids
  [all-analyses search-construct-ids]
  (let [display-construct-ids (->> all-analyses
                                   (keep
                                    (fn [{:keys [construct-id] :as sa}]
                                      (when (contains? search-construct-ids
                                                       construct-id)
                                        (vec (apply conj
                                                    (conj (:tree/ancestors sa) construct-id)
                                                    (:tree/children sa))))))
                                   flatten
                                   set
                                   (set/union search-construct-ids))]
    display-construct-ids))

(defn ListItemAnalysisRow
  [{:keys [active-query
           analysis-linked
           context
           control
           display-construct-ids
           expand-all
           expanded
           linked-construct-ids
           on-click-construct
           on-click-state
           on-expand
           search-result-construct-ids
           disabled-construct-ids
           selected-construct-ids]
    :as props}
   asa]
  (let [linked-construct-ids (or linked-construct-ids #{})
        is-expanded (contains? (set expanded) (:construct-id asa))
        is-parent-expanded (contains? (set expanded) (:parent-id asa))
        hierarchy-indent (when (pos? (:tree/depth asa))
                           (into [:<>]
                                 (mapv (fn [_]
                                         [:div
                                          {:class (if is-parent-expanded
                                                    :tree-hierarchy-spacer--parent-expanded
                                                    :tree-hierarchy-spacer)}])
                                       (range 0 (:tree/depth asa)))))
        list-item-class [(when active-query
                           (if (contains? (set search-result-construct-ids) (:construct-id asa))
                           :tree-hierarchy-node--search-result
                           :tree-hierarchy-node--disabled))
                         (if (and (contains? (set linked-construct-ids) (:construct-id asa))
                                  (not is-expanded))
                           :is-inactive
                           (if is-expanded
                             :tree-hierarchy-node--expanded
                             (when (seq (:tree/children asa)) :is-tertiary)))
                         (if is-parent-expanded
                           :tree-hierarchy-node--parent-expanded
                           :tree-hierarchy-node)]
        is-disabled (contains? (or disabled-construct-ids #{}) (:construct-id asa))]

    (when (row-visible? is-expanded
                        asa
                        props)
      [:div.analysis--listitem-analysis-row.level-left.my-0.is-flex-grow-1.is-flex-shrink-1
       {:class list-item-class}
       [:div.level-left.my-0.p-0.is-flex-grow-1.is-flex-shrink-1.is-flex
        ; Hierarchy Spacing
        hierarchy-indent

        [:div.analysis--listitem-analysis-row-spacer
         {:style {:min-width (if (zero? (:tree/depth asa))
                              "72px"
                              "64px")}}
         (when (seq (:tree/children asa))
           [:button.button.my-0
            {:style {:height "30px"}
             :class (if is-expanded :is-info :is-secondary)
             :on-click (if (seq (:tree/children asa))
                         #(on-expand asa)
                         identity)}
            (when (seq (:tree/children asa))
              [:div.level.my-0
               (if is-expanded
                 [:i.icon.fas.fa-folder-open.mr-0]
                 [:i.icon.fas.fa-folder-plus.mr-0])
               (when-not expand-all
                 [:span.is-size-7 (count (:tree/children asa))])])])]
        (when control control)
        [:div {:class (when is-disabled :no-pointer-events)}
         [analysis.list/AnalysisState asa on-click-state]]
        [:div.level.is-flex-grow-1
         (when is-disabled
           {:style {:text-decoration "line-through"
                    :background-color "#CCC"}
            :class :no-pointer-events})
         [analysis.list/AnalysisConstruct asa on-click-construct]
         (let [controls-met (-> asa :applied-analyses first :controls-met)
               all-controls (-> asa :applied-analyses first :evidence-count)
               invalid-evidence (-> asa :applied-analyses first :invalid-evidence)]
           [:div.mr-2.level
            (when (pos? all-controls)
              [:div.title.is-size-7.my-0.is-inline
               [:i.icon.fas.fa-trowel-bricks]
               (str controls-met "/" all-controls)])
            (when (and (pos? all-controls)
                       (pos? invalid-evidence))
              [:span.mx-2 " - "])
            (when (pos? invalid-evidence)
              [:span.title.is-size-7
               [:i.icon.fas.fa-triangle-exclamation.mr-1]])])]]
       (when (contains? (set linked-construct-ids) (:construct-id asa))
         [:div.ml-4.is-size-7 "Already Added"])])))

(defn CheckboxAnalysisRow
  [{:keys [disabled
           on-select
           expanded
           expand-all
           analysis-linked
           active-query
           linked-construct-ids
           selected-construct-ids
           disabled-construct-ids
           display-construct-ids
           search-construct-ids
           on-expand]
    :as props}
   asa]
  [:<>
   [ListItemAnalysisRow
   (assoc props :control
          [:input.mr-2
           {:type :checkbox
            :disabled (or disabled
                          (contains? (set linked-construct-ids) (:construct-id asa))
                          (contains? (set disabled-construct-ids) (:construct-id asa)))
            :checked (or (contains? selected-construct-ids (:construct-id asa))
                         (contains? (set linked-construct-ids) (:construct-id asa)))
            :on-change (fn [] (on-select asa))}])
   asa]])

(defn get-child-count
  [category analysis-by-category active-query search-result-construct-ids]
  (cond->> (get analysis-by-category category)
    active-query
    (filter #(contains? search-result-construct-ids (:construct-id %)))
    :always
    count))

(defn AnalysisTree
  [{:keys [active-query
           analyses
           category
           expand-all
           hide-category
           hide-category-selection
           on-click-construct
           on-click-state
           on-select
           preselected-version-ids
           row-component
           search-result-construct-ids
           disabled-construct-ids
           selected-version-ids]}]
  (let [display-construct-ids (get-analysis-tree-displayed-construct-ids
                                analyses
                                search-result-construct-ids)
        [expanded set-expanded] (react/useState [])
        [active-category set-active-category] (react/useState category)
        all-categories (->> analyses
                            (map :categories)
                            flatten
                            (map :name)
                            distinct
                            (sort-by (fn [name]
                                       [(not (#{"Policy" "Operations (process)"} name))
                                        name])))

        analysis-by-category (group-by (comp :name first :categories) analyses)
        category-analyses (get analysis-by-category active-category)

        handle-expanded (fn [asa]
                          (if (contains? (set expanded) (:construct-id asa))
                            (set-expanded #(filterv (fn [construct-id]
                                                      (not (contains? (conj (:tree/children asa)
                                                                            (:construct-id asa))
                                                                      construct-id)))
                                                    %))
                            (set-expanded (conj (if (and active-query
                                                         (not (contains? (set expanded) (:parent-id asa))))
                                                  []
                                                  (vec (:tree/ancestors asa)))
                                                (:construct-id asa)))))
        linked-construct-ids (->> category-analyses
                                  (keep (fn [{:keys [applied-analyses]}]
                                          (let [latest-applied-analysis (first applied-analyses)]
                                            (when (contains? (set preselected-version-ids)
                                                             (:version-id latest-applied-analysis))
                                              (:construct-id latest-applied-analysis)))))
                                  set)
        selected-construct-ids (->> category-analyses
                                    (keep (fn [{:keys [applied-analyses] :as sa}]
                                            (let [latest-applied-analysis (first applied-analyses)]
                                              (when (or (contains? (set selected-version-ids)
                                                                   (:version-id sa))
                                                        (contains? (set selected-version-ids)
                                                                   (-> sa :applied-analyses first :version-id)))
                                                (:construct-id latest-applied-analysis)))))
                                    set)]

    (react/useEffect
     (fn [_]
       ;; If a search returns 0 results for the active category, we update the
       ;; active category to the first category with some results
       (when (zero? (get-child-count active-category
                                     analysis-by-category
                                     active-query
                                     search-result-construct-ids))
         (set-expanded [])
         (some->> all-categories
                  (some #(and (->> (get-child-count %
                                                    analysis-by-category
                                                    active-query
                                                    search-result-construct-ids)
                                   pos?)
                              %))
                  set-active-category)))
     #js [search-result-construct-ids])

    [:<> {:key [active-category display-construct-ids]}
     (when-not hide-category-selection
       (->> all-categories
            (mapv (fn [cat]
                    (let [child-count (get-child-count cat
                                                       analysis-by-category
                                                       active-query
                                                       search-result-construct-ids)]
                      [:button.button
                       {:class (if (= cat active-category) :is-info :is-tertiary)
                        :on-click #(set-active-category cat)
                        :disabled (zero? child-count)}
                       cat
                       " (" child-count ")"])))
            (into [:div.buttons.my-1])))
     (->> category-analyses
          (map (fn [{:keys [applied-analyses] :as structured-analysis}]
                 (let [latest-applied-analysis (first applied-analyses)]
                   (assoc structured-analysis
                          :state-id (:state-id latest-applied-analysis)
                          :applied-analyses-outdated (analysis.profile/latest-applied-outdated structured-analysis)
                          :linked-construct-ids linked-construct-ids
                          :selected-construct-ids selected-construct-ids
                          :analysis-linked (contains? preselected-version-ids (:version-id latest-applied-analysis))))))
          (analysis.list/AnalysisCategoryTable
           hide-category
           (partial row-component
                    {:on-select on-select
                     :on-click-construct on-click-construct
                     :on-click-state on-click-state
                     :selected-construct-ids selected-construct-ids
                     :on-expand handle-expanded
                     :disabled-construct-ids disabled-construct-ids
                     :expanded expanded
                     :expand-all expand-all
                     :active-query active-query
                     :linked-construct-ids linked-construct-ids
                     :search-result-construct-ids search-result-construct-ids
                     :display-construct-ids display-construct-ids})))]))
